<template lang="html">
  <v-card height="99%" style="position: absolute">
    <WorkBenchView>
      <template #navigation>
        <StandardNavigationCard
        icon="list"
        name="TAKT.steps"
        :cols="getCols()"
        :navigation_list="workstep_nav_list"
        >
      </StandardNavigationCard>
        <StandardNavigationCard
          icon="dns"
          name="TAKT.packages"
          :cols="getCols()"
          :navigation_list="workpackage_nav_list"
          >
        </StandardNavigationCard>
        <StandardNavigationCard
          icon="train"
          name="TAKT.sequences"
          :cols="getCols()"
          :navigation_list="sequence_nav_list"
          >
        </StandardNavigationCard>
      </template>
    </WorkBenchView>
  </v-card>
</template>

<script>
import WorkBenchView from '@/components/WorkBench/WorkBenchView.component.vue';
import StandardNavigationCard from '@/components/StandardComponents/StandardNavigationCard.component.vue';
export default {
  name: 'WorkBench',
  components: {
    WorkBenchView,
    StandardNavigationCard
  },
  data: function () {
    return {
      workstep_nav_list: [
        {
          text: 'Build your own...',
          to: {name: 'CustomWorkStep', query: { editor: 'true' } }
        },
        {
          text: 'Manage your own...',
          to: {name: 'CustomWorkStep'}
        },
        {
          text: 'Community solutions...',
          to: {name: 'CommunityWorkSteps'}
        }
      ],
      workpackage_nav_list: [
        {
          text: 'Build your own...',
          to: {name: 'CustomWorkPackage', query: { editor: 'true' } }
        },
        {
          text: 'Manage your own...',
          to: {name: 'CustomWorkPackage'}
        },
        {
          text: 'Community solutions...',
          to: {name: 'CommunityWorkPackages'}
        }
      ],
      sequence_nav_list: [
        {
          text: 'Build your own...',
          to: {name: 'CustomSequence', query: { editor: 'true' } }
        },
        {
          text: 'Manage your own...',
          to: {name: 'CustomSequence'}
        },
        {
          text: 'Community solutions...',
          to: {name: 'CommunitySequences'}
        }
      ],
    }
  },
  methods: {
    getCols(){
      if (this.$vuetify.breakpoint.smAndDown) {
        return 12;
      } else if(this.$vuetify.breakpoint.mdOnly) {
        return 6;
      } else {
        return 4;
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
